/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { Switch, Route, Redirect } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { CssBaseline } from '@material-ui/core'
import { useStyles } from './style/Layout'
import Notifications from '../Notifications/Notifications'
import TaskLanding from '../Task/TaskLanding'
import VendorPipelineLanding from '../Vendor/VendorPipelineLanding'
import NotFound from '../../components/NotFoundPage/NotFoundPage'
import Auth, { isTPlus } from '../Auth/Auth'
import { MainContent } from './LayoutStyle'
import { TaskContextProvider } from '../Task/TaskContext'
import { VendorContextProvider } from '../Vendor/VendorContext.js'
import LayoutHeader from './LayoutHeader'
import { signInSuccess } from '../Auth/AuthActionCreator'
import NBrProjectList from '../NationalBrand/NBrProjectList'
import { NBrProjectDetails } from '../NationalBrand/NBrProjectDetails'
//Dashboard
import NBrDashboard from '../NationalBrand/NBrDashboard/NBrDashboard'
import { vendorInfo } from '../store/NationalBrand/ActionCreator'
import LegalWarningModal from '../NationalBrand/NbrLegalWarning'
import { INTIAL_STATE_TYPE } from '../store/NationalBrand/ActionType.js'
import { ACCESS_DENIED_URL } from '../../config/apiConfig.js'
import Support from '../../components/Support/Support.js'

const Layout = (props) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { nbrVendorConfirm } = useSelector((state) => state.nationalBrand)
  const { session, location, isAuthorized, logout } = props
  const [userAccess, setUserAccess] = useState(false)
  useEffect(() => {
    if (session.userInfo.accessToken) {
      dispatch(signInSuccess(session.userInfo))
      dispatch(vendorInfo(session.userInfo.email))
    }
  }, [dispatch, location, session, isAuthorized])

  useEffect(() => {
    if (
      isTPlus &&
      !nbrVendorConfirm.nbrVendorAPIStatus &&
      nbrVendorConfirm.nbrVendorAPIStatus !== INTIAL_STATE_TYPE
    ) {
      //Non authorized user
      window.location.href = ACCESS_DENIED_URL
    } else if (nbrVendorConfirm && nbrVendorConfirm.vendor_id !== undefined) {
      setUserAccess(true)
    }
  }, [nbrVendorConfirm])

  return (
    <div className={classes.root}>
      <Helmet defaultTitle="Gargantua" titleTemplate="%s - Gargantua" />
      <Auth
        accessToken={session && session.userInfo.accessToken}
        session={session}
        {...props}
      />
      <Notifications />
      <CssBaseline />
      <LayoutHeader
        logout={logout}
        {...props}
        nbrVendorConfirm={userAccess === true || isTPlus}
      />
      <MainContent>
        <Switch>
          {!isTPlus ? (
            <Route
              exact
              path="/"
              render={(props) => (
                <TaskContextProvider>
                  <TaskLanding {...props} />
                </TaskContextProvider>
              )}
            />
          ) : null}
          {!isTPlus ? (
            <Route
              exact
              path="/pipeline"
              render={(props) => (
                <VendorContextProvider>
                  <VendorPipelineLanding {...props} />
                </VendorContextProvider>
              )}
            />
          ) : null}

          {isTPlus ? (
            <Route exact path="/" render={() => <Redirect to="/projects" />} />
          ) : null}

          {/* /National Brand route /  */}
          {userAccess === true || isTPlus ? (
            <Route
              exact
              path="/projects"
              render={(props) => <NBrProjectList {...props} />}
            />
          ) : null}
          {userAccess === true || isTPlus ? (
            <Route
              exact
              path="/projects/:projectId"
              render={(props) => <NBrProjectDetails {...props} />}
            />
          ) : null}

          {/* /National Brand Route / */}
          {userAccess === true || isTPlus ? (
            <Route exact path="/dashboard" render={() => <NBrDashboard />} />
          ) : null}

          <Route exact path="/support" render={() => <Support />} />

          <Route component={NotFound} />
        </Switch>
      </MainContent>
      {isTPlus && <LegalWarningModal logout={logout} />}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    accessToken: state.auth.accessToken,
    displayName: state.auth.displayName,
    company: state.auth.company,
    isSignedIn: state.auth.isAuthorized,
  }
}

export default connect(mapStateToProps)(Layout)
